import { render } from "./CardSub.vue?vue&type=template&id=1af0141a"
import script from "./CardSub.vue?vue&type=script&lang=js"
export * from "./CardSub.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Data/lms_hosting_12/packages/mediatis_slideshow_leica/Resources/Private/JavaScript/flx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__